import { render, staticRenderFns } from "./MKBroot.vue?vue&type=template&id=0020ff86&scoped=true"
import script from "./MKBroot.vue?vue&type=script&lang=js"
export * from "./MKBroot.vue?vue&type=script&lang=js"
import style0 from "./MKBroot.vue?vue&type=style&index=0&id=0020ff86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020ff86",
  null
  
)

export default component.exports